import { makeStyles } from '@mui/styles';

export const useErrorAlertStyles = makeStyles({
  alert: {
    maxWidth: '600px',
    margin: '5px 0'
  },
  text: {
    fontSize: '14px'
  }
});
